import script from "./CredentialsSniffer.vue?vue&type=script&setup=true&lang=ts"
export * from "./CredentialsSniffer.vue?vue&type=script&setup=true&lang=ts"

import "./CredentialsSniffer.vue?vue&type=style&index=0&id=7a3ae42f&lang=scss"

export default script